<template>
    <div>
        <b-modal
            id="exportAppointmentModal"
            ref="exportAppointmentModal"
            :title="
                (data.export_type === 1 ? 'Email' : 'Print') + ' Appointments'
            "
            :lazy="true"
            title-tag="h2"
        >
            <form class="form-horizontal">
                <div class="form-group row">
                    <label for="staffs" class="col-sm-3 col-form-label"
                        >Assigned To:</label
                    >
                    <div class="col-sm-9">
                        <v-select
                            id="staffs"
                            ref="vselect"
                            :options="staff_options_exclude"
                            v-model="data.staffs"
                            v-validate="'required'"
                            :label="'fullname'"
                            :class="{ 'border-danger': errors.has('staffs') }"
                            name="staffs"
                            placeholder="Select staff member(s) (required)"
                            multiple
                        />
                    </div>
                </div>
                <div v-if="data.export_type == 1" class="form-group row">
                    <label for="recepients" class="col-sm-3 col-form-label"
                        >Email To:</label
                    >
                    <div class="col-sm-9">
                        <v-select
                            id="recepients"
                            ref="vselect"
                            :options="recepients_options_exclude"
                            :class="{
                                'border-danger': errors.has('recepients')
                            }"
                            v-model="data.recepients"
                            v-validate="'required'"
                            :label="'fullname'"
                            name="recepients"
                            placeholder="Select staff member(s) (required)"
                            multiple
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="start" class="col-sm-3 col-form-label"
                        >Start:</label
                    >
                    <div class="col-sm-9">
                        <date-picker
                            :config="datePickerOptions"
                            :value="data.start"
                            @dp-change="dateChange($event, 'start')"
                            v-validate="'required'"
                            class="form-control"
                            name="start"
                        ></date-picker>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="end" class="col-sm-3 col-form-label"
                        >End:</label
                    >
                    <div class="col-sm-9">
                        <date-picker
                            :config="datePickerOptions"
                            :value="data.end"
                            @dp-change="dateChange($event, 'end')"
                            v-validate="'required'"
                            class="form-control"
                            name="end"
                        ></date-picker>
                    </div>
                </div>
                <div v-if="data.export_type == 1" class="form-group row">
                    <label for="note" class="col-sm-3 col-form-label"
                        >Notes:</label
                    >
                    <div class="col-sm-9">
                        <textarea
                            id="note"
                            v-model="data.note"
                            class="form-control"
                            style="height: 130px !important;"
                        ></textarea>
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.exportAppointmentModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="save" v-else variant="primary"
                        >Save</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import vSelect from "vue-select";

export default {
    components: {
        vSelect
    },
    data() {
        return {
            data: {
                export_type: null,
                staffs: [],
                recepients: [],
                start: null,
                end: null,
                note: null
            },
            staffList: [],
            receipentList: [],
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            loading: false
        };
    },
    computed: {
        staff_options_exclude() {
            return _.difference(this.staffList, this.data.staffs);
        },
        recepients_options_exclude() {
            return _.difference(this.receipentList, this.data.recepients);
        }
    },
    methods: {
        open(event) {
            this.getStaffList();

            this.datePickerOptions.format = this.getDateFormat();

            this.data.export_type = event;
            this.data.start = moment().tz(this._timeZone);
            this.data.end = moment().tz(this._timeZone);

            if (this.data.export_type == 1) {
                this.getReceipientList();
                this.data.note =
                    "Hi,\n\nBelow is a link to the appointments.\n\nThanks,\n" +
                    this.$root.currentActor.fullname;
            }

            this.$refs.exportAppointmentModal.show();
        },
        getStaffList() {
            let self = this;

            this.$http
                .get(
                    process.env.BARRACUDA +
                        "account/schedule-columns?is_settings=0"
                )
                .then(function (response) {
                    self.staffList = response.data.response.resource.data;
                    self.staffList = _.map(self.staffList, element => ({
                        ...element,
                        id: element.type == 1 ? element.staff.id : element.id,
                        fullname:
                            (element.display_name == null ||
                                element.display_name == "") &&
                            element.type == 1
                                ? element.staff.firstname +
                                  " " +
                                  element.staff.lastname
                                : element.display_name
                    }));

                    self.data.staffs = self.staffList.filter(elem =>
                        elem.staff
                            ? elem.staff.id == self.$root.currentActor.id
                            : false
                    );
                });
        },
        getReceipientList() {
            let self = this;
            this.$http
                .get(process.env.ACTOR_SERVICE + "staff")
                .then(function (response) {
                    self.receipentList = response.data.response.resources;

                    self.data.recepients = self.receipentList.filter(
                        elem => elem.id == self.$root.currentActor.id
                    );
                    self.$validator.reset();
                });
        },
        dateChange(event, element) {
            this.data[element] = event.date;
        },
        async save() {
            let self = this;
            if (!(await self.$validator.validateAll())) {
                return false;
            }

            self.loading = true;

            let post = {
                export_type: self.data.export_type,
                end_date: moment(self.data.end).format(
                    self.datePickerOptions.format
                ),
                start_date: moment(self.data.start).format(
                    self.datePickerOptions.format
                ),
                by: [],
                to: [],
                note: null
            };

            post.by = [];
            post.to = [];

            $.each(self.data.staffs, function (index, value) {
                post.by.push([value.id, value.type]);
            });

            if (post.export_type == 1) {
                $.each(self.data.recepients, function (index, value) {
                    if (value.email) {
                        post.to.push(value.email);
                    }
                });

                post.note = self.data.note;
            }

            let response = await this.$http.post(
                process.env.SCHEDULE_SERVICE + "export-appointment",
                post
            );
            if (response) {
                if (response.data.response.message.code == 200) {
                    self.$refs.exportAppointmentModal.hide();
                    if (response.data.response.resource.path) {
                        window.open(response.data.response.resource.path);
                    } else {
                        self.$root.$emit(
                            "message",
                            response.data.response.resource.message,
                            "success"
                        );
                    }
                } else {
                    self.$root.$emit(
                        "message",
                        response.data.response.message,
                        "danger"
                    );
                }
            }
            self.loading = false;
        }
    }
};
</script>
